/** Simulation ticks per second. The renderer interpolates between ticks. */
export const TICKS_PER_SECOND = 60;
export const TICK_MS = 1000 / TICKS_PER_SECOND;

/** Size of one map tile in world pixels. */
export const TILE = 16;

/** Playable depth lanes per room: 0 = near (default), 1 = middle, 2 = far. */
export const LANE_COUNT = 3;
